import { Component, EventEmitter, Output, ChangeDetectionStrategy, Input } from '@angular/core';
import { ICON_QUESTION_MARK } from '../../named-icons.config';

@Component({
  selector: 'app-confirmation',
  templateUrl: 'confirmation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationComponent {
  @Input()
  public modalTitle: string;

  @Input()
  public modalMessage: string;

  @Input()
  public modalCancelButton: string;

  @Input()
  public modalOkButton: string;

  @Output()
  public answer: EventEmitter<boolean> = new EventEmitter<boolean>();

  public readonly ICONS = {
    ICON_QUESTION_MARK,
  };

}
